import { getSelectedAccountInfo } from '@ibk/shared-auth';
import { baseApi } from '@ibk/shared-config';
export const receiptApi = baseApi.injectEndpoints({
    endpoints: builder => ({
        getTedReceipt: builder.query({
            query: ({ id }) => ({
                url: `/v1/ted/${id}/receipt`,
                forceSelectedAccountInfoAccountId: true,
                forceAccountantApiBaseUrl: true,
            }),
        }),
        getTedReceiptV2: builder.query({
            query: ({ id }) => {
                const partyId = getSelectedAccountInfo()?.targetId;
                return {
                    url: `/v2/ted/${id}/receipt`,
                    forceSelectedAccountInfoAccountId: true,
                    forceAccountantApiBaseUrl: true,
                    ...(partyId && { headers: { 'x-tr-party-selected': partyId } }),
                };
            },
        }),
        getP2PReceipt: builder.query({
            query: ({ transactionId, coreBankId }) => ({
                url: `/v1/p2p/receipt/${transactionId}/detail/${coreBankId}`,
                forceSelectedAccountInfoAccountId: true,
                forceAccountantApiBaseUrl: true,
            }),
        }),
        getP2PReceiptV2: builder.query({
            query: ({ id }) => {
                const partyId = getSelectedAccountInfo()?.targetId;
                return {
                    url: `/v2/p2p/receipt/${id}`,
                    forceSelectedAccountInfoAccountId: true,
                    forceAccountantApiBaseUrl: true,
                    ...(partyId && { headers: { 'x-tr-party-selected': partyId } }),
                };
            },
        }),
        getV1PixReceipt: builder.query({
            query: ({ id, instructionFlow }) => ({
                url: `/v1/pix/receipt/${id}`,
                params: {
                    instructionFlow,
                },
                forceSelectedAccountInfoAccountId: true,
                forceAccountantApiBaseUrl: true,
            }),
        }),
        getV2PixReceipt: builder.query({
            query: ({ id, instructionFlow }) => ({
                url: `/v2/pix/receipt/${id}`,
                params: {
                    instructionFlow,
                },
                forceSelectedAccountInfoAccountId: true,
                forceAccountantApiBaseUrl: true,
            }),
        }),
        getV3PixReceipt: builder.query({
            query: ({ id, flow }) => {
                const partyId = getSelectedAccountInfo()?.targetId;
                return {
                    url: `/v3/pix/receipt/${id}/flow/${flow}`,
                    forceSelectedAccountInfoAccountId: true,
                    forceAccountantApiBaseUrl: true,
                    ...(partyId && { headers: { 'x-tr-party-selected': partyId } }),
                };
            },
        }),
        getPixScheduleReceipt: builder.query({
            query: ({ id }) => ({
                url: `/v1/schedule/${id}`,
                forceSelectedAccountInfoAccountId: true,
                forceAccountantApiBaseUrl: true,
            }),
        }),
        getPaidBilletReceipt: builder.query({
            query: ({ transactionId, coreBankId }) => ({
                url: `/v1/billet/receipt/${transactionId}/detail/${coreBankId}`,
                forceSelectedAccountInfoAccountId: true,
                forceAccountantApiBaseUrl: true,
            }),
        }),
        getPaidBankSlipReceipt: builder.query({
            query: ({ id }) => ({
                url: `/v1/bankslip/receipt/${id}`,
                forceSelectedAccountInfoAccountId: true,
                forceAccountantApiBaseUrl: true,
            }),
        }),
        getBankSlipReceiptV2: builder.query({
            query: ({ id, flow }) => {
                const partyId = getSelectedAccountInfo()?.targetId;
                return {
                    url: `/v2/bankslip/receipt/${id}/flow/${flow}`,
                    forceSelectedAccountInfoAccountId: true,
                    forceAccountantApiBaseUrl: true,
                    ...(partyId && { headers: { 'x-tr-party-selected': partyId } }),
                };
            },
        }),
        getChargeBilletReceipt: builder.query({
            query: ({ transactionId, coreBankId }) => ({
                url: `/v1/billet/received/receipt/${transactionId}/detail/${coreBankId}`,
                forceSelectedAccountInfoAccountId: true,
                forceAccountantApiBaseUrl: true,
            }),
        }),
        getScheduleBilletReceipt: builder.query({
            query: ({ id }) => ({
                url: `/v1/schedule/${id}`,
                forceSelectedAccountInfoAccountId: true,
                forceAccountantApiBaseUrl: true,
            }),
        }),
        getSlipList: builder.query({
            query: ({ orderBy = 'createdAt', page = 1, pageSize = 10, sort = 'desc', limit = 10 }) => ({
                url: `/v1/slip`,
                params: { orderBy, page, pageSize, sort, limit },
                forceSelectedAccountInfoAccountId: true,
                forceAccountantApiBaseUrl: true,
            }),
        }),
        getSlipPdf: builder.query({
            query: ({ slipId }) => ({
                url: `/v1/slip/generate-pdf/${slipId}`,
                forceSelectedAccountInfoAccountId: true,
                forceAccountantApiBaseUrl: true,
            }),
        }),
        cancelCharge: builder.mutation({
            query: ({ chargeId }) => ({
                url: `/v1/bankslip/${chargeId}`,
                method: 'DELETE',
                forceSelectedAccountInfoAccountId: true,
                forceAccountantApiBaseUrl: true,
            }),
        }),
        createDepositBillet: builder.mutation({
            query: ({ amount, bankEmissor = 1 }) => ({
                url: `/v1/slip/receive-from-yourself`,
                method: 'POST',
                body: { amount, bankEmissor },
                forceSelectedAccountInfoAccountId: true,
                forceAccountantApiBaseUrl: true,
            }),
        }),
    }),
});
export const { useLazyGetTedReceiptQuery, useLazyGetTedReceiptV2Query, useLazyGetP2PReceiptQuery, useLazyGetP2PReceiptV2Query, useLazyGetV1PixReceiptQuery, useLazyGetV2PixReceiptQuery, useLazyGetV3PixReceiptQuery, useLazyGetPixScheduleReceiptQuery, useLazyGetPaidBilletReceiptQuery, useLazyGetPaidBankSlipReceiptQuery, useLazyGetBankSlipReceiptV2Query, useLazyGetChargeBilletReceiptQuery, useLazyGetScheduleBilletReceiptQuery, useLazyGetSlipListQuery, useLazyGetSlipPdfQuery, useCancelChargeMutation, useCreateDepositBilletMutation, } = receiptApi;
